import { render } from "./comprehensiveAnswer.vue?vue&type=template&id=01577446&scoped=true"
import script from "./comprehensiveAnswer.vue?vue&type=script&lang=js"
export * from "./comprehensiveAnswer.vue?vue&type=script&lang=js"

import "./comprehensiveAnswer.vue?vue&type=style&index=0&id=01577446&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01577446"]])

export default __exports__